import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LeadService from "../../services/leads.service";

export const getLead = createAsyncThunk(
  "lead/getLead",
  async (params, thunkAPI) => {
    try {
      const response = await LeadService.getLead(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addLead = createAsyncThunk(
  "lead/addLead",
  async (data, thunkAPI) => {
    try {
      const response = await LeadService.addLead(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const leadSync = createAsyncThunk(
  "lead/leadSync",
  async (data, thunkAPI) => {
    try {
      const response = await LeadService.leadSync(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getLeadActivity = createAsyncThunk(
  "lead/getLeadActivity",
  async (params, thunkAPI) => {
    try {
      const response = await LeadService.getLeadActivity(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addLeadActivity = createAsyncThunk(
  "lead/addLeadActivity",
  async (data, thunkAPI) => {
    try {
      const response = await LeadService.addLeadActivity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateLead = createAsyncThunk(
  "lead/updateLead",
  async (payload, thunkAPI) => {
    try {
      const response = await LeadService.editLead(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteLead = createAsyncThunk(
  "lead/deleteLead",
  async (id, thunkAPI) => {
    try {
      await LeadService.deleteLead(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  leadList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getLead.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLead.fulfilled, (state, action) => {
        state.loading = false;

        state.leadList = action.payload?.leads || [];
        state.total = action.payload?.total || 0;
        state.page = action.payload?.page || 1;
        state.pages = action.payload?.pages || 1;
      })
      .addCase(getLead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      /* ---------- Add ---------- */
      .addCase(addLead.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addLead.fulfilled, (state, action) => {
        state.loading = false;
        const newlead =
          action.payload?.data ||
          action.payload?.leads ||
          action.payload;

        if (newlead) {
          state.leadList.unshift(newlead);
        }
      })
      .addCase(addLead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateLead.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateLead.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.leads;

        if (updated?._id) {
          const index = state.leadList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.leadList[index] = updated;
          }
        }
      })
      .addCase(updateLead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Lead Sync ---------- */
      .addCase(leadSync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(leadSync.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(leadSync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteLead.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLead.fulfilled, (state, action) => {
        state.loading = false;
        state.leadList = state.leadList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteLead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = leadSlice.actions;
export default leadSlice.reducer;
